/* Back9Lab V2 (4 nov 2026): altijd de Rebuy Smart Cart, nooit de oude /cart-pagina.
   - Elke link naar /cart (header-icoon, 'View cart' in de toast, menu's) opent de Rebuy-cart, ook als Rebuy al geladen is.
   - Komt iemand toch op /cart (bijv. via de winkelwagen in de checkout), dan stuurt de inline code in theme.liquid
     terug naar de vorige pagina en opent deze code daar de Rebuy-cart (vlag b9OpenCart in sessionStorage).
   - Laadt Rebuy niet binnen 15 s, dan pas naar /cart?b9cart=page (terugval, de pagina blijft dan staan). */
(function () {
  if (window.B9CartV2) return;
  window.B9CartV2 = true;
  var FALLBACK = '/cart?b9cart=page';
  function ready() {
    return window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show == 'function';
  }
  function isCartLink(a) {
    var href = a.getAttribute('href');
    if (!href || a.target === '_blank' || a.hasAttribute('download')) return false;
    try {
      var u = new URL(a.href, location.href);
      return u.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(u.pathname) && !u.search;
    } catch (e) { return false; }
  }
  function closeToast(a) {
    var t = a.closest('.b9-toast');
    if (t) { var x = t.querySelector('.b9-toast__x, [aria-label="Close"]'); if (x) x.click(); else t.remove(); }
  }
  // Laadpaneel (inline in theme.liquid): verschijnt meteen, Rebuy neemt het over zodra die klaar is
  function loading(on) { if (typeof window.B9CartLoading == 'function') try { window.B9CartLoading(on); } catch (e) {} }
  function show() {
    try { window.Rebuy.SmartCart.show(); } catch (e) { location.href = FALLBACK; return; }
    setTimeout(function () { loading(false); }, 350); // pas weg als de Rebuy-cart ingeschoven is
  }
  var waiting = false;
  function openCart() {
    window.B9CartCancel = false;
    if (ready()) { show(); return; }
    loading(true);
    if (waiting) return;
    waiting = true;
    if (typeof window.loadJSscripts == 'function') try { window.loadJSscripts(); } catch (e) {}
    var t0 = Date.now();
    (function wait() {
      if (window.B9CartCancel) { waiting = false; return; } // klant sloot het laadpaneel
      if (ready()) { waiting = false; show(); return; }
      if (Date.now() - t0 > 15000) { waiting = false; location.href = FALLBACK; return; }
      setTimeout(wait, 50);
    })();
  }
  window.B9OpenCart = openCart;
  // Capture op window: vóór b9-qv.js en vóór de eigen handler van Rebuy, zodat er maar één keer geopend wordt
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !isCartLink(a) || a.closest('#rebuy-cart, .rebuy-cart__flyout')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    closeToast(a);
    openCart();
  }, true);
  // Na een doorverwijzing vanaf /cart de Rebuy-cart openen
  var flag = null;
  try { flag = sessionStorage.getItem('b9OpenCart'); sessionStorage.removeItem('b9OpenCart'); } catch (e) {}
  if (flag) openCart();
})();
